import axios, { AxiosError } from "axios";
import { GET_COURSE_DEFINITION_LIST, GET_COURSE_INSTANCE_DEFINITION_LIST, GET_COURSE_COUNT_CARD, DELETE_COURSE_DEFINITION_API, DELETE_COURSE_INSTANCE_API } from "../../../../../../src/common/apiEndPoint/apiEndPoint";
import config from "../../../../../common/authentication/config";

export const orgNameStatic = config?.ACADEMY_ORGNAME;
export const siteIdStatic = config?.SITE_ID;

export const getCourseCountData = async (requestParams: any) => {
  try {
    const res: any = await axios.get(`${GET_COURSE_COUNT_CARD}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic
        },
      }
    );
      return {
        success: true,
        data: res.data.courseCountData || []
      };
  } catch (error) { 
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occurred",
    }
  }
};

export const getCourseViewTemplateData = async (requestParams: any) => {
  try {
    const pageSize = requestParams.pageSize || 200;
    const pageNumber = requestParams.pageNumber;
    let courseStage = '';
    if(requestParams.courseStage === "Published"){
      courseStage = "Published";
    } else if(requestParams.courseStage === "Draft"){
      courseStage = "Draft";
    } else {
      courseStage = "All";
    }
    
    const res: any = await axios.get(
      `${GET_COURSE_DEFINITION_LIST}?pageNo=${pageNumber}&pageSize=${pageSize}&courseStage=${courseStage}`,
      {
        headers: {
          Authorization: `Bearer ${requestParams.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic
        },
      }
    );
    return {
      success: true,
      data: res.data
    }
  } catch (error) {
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occured",
    }
  }
};

export const getCourseInstanceViewTemplateData = async (requestParams: any) => {
  try {
    const pageNumber = requestParams?.pageNumber;
    const pageSize = requestParams?.pageSize;
    const accessToken = requestParams?.accessToken;
    
    const res: any = await axios.get(
      `${GET_COURSE_INSTANCE_DEFINITION_LIST}?pageNumber=${pageNumber}&pageSize=${pageSize}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic
        },
      }
    );
    return {
      success: true,
      data: res.data
    }
  } catch (error) {
    return {
      success: false,
      status: (error as AxiosError)?.status || 500,
      message: (error as AxiosError)?.response?.data || "Unknown error occured",
    }
  }
};

export const deleteCourseTemplate = async (requestParams: any) => {
  try {
    const res: any = await axios.delete(
      `${DELETE_COURSE_DEFINITION_API}`,
      {
        data: requestParams,
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic
        }
      }
    );
    return {
      status: res.status,
      message: res.data
    };
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return {
      status: axiosError.response?.status,
      message: axiosError.response?.data,
    };
   }
};

export const deleteCourseInstance = async (requestParams: any) => {
  try {
    const res: any = await axios.delete(
      `${DELETE_COURSE_INSTANCE_API}`,
      {
        data: requestParams,
        headers: {
          Authorization: `Bearer ${requestParams?.accessToken}`,
          Accept: "application/json",
          OrgName: orgNameStatic,
          SiteId: siteIdStatic
        }
      }
    );
    return {
      status: res.status,
      message: res.data.message
    };
  } catch (error) {
    const axiosError = error as AxiosError<{ message?: string }>;
    return {
      status: axiosError.response?.status,
      message: axiosError.response?.data,
    };
  }
}